export default __webpack_public_path__ + "static/media/password-reset-active.d93820ea.svg";